import { apiClient } from "helpers/api_helper";

export const getCartDetails = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/cart/GetSalesEntryCartDataGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getCartDetailsById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/cart/GetCartItemDetailsByCartId?cartid=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const deleteProductById = async (id: any, productHeaderId:any) => {
    try {
        const response = await apiClient.delete(`/api/v1/cart/RemoveProductHeaderIdFromCart?cartId=${productHeaderId}&productHeaderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};